import { Component, OnInit, ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { HaPatientlistService } from '../../services/HaPatientList.service';
import { PdfData } from '../../../PatientPanel/models/PdfData.model';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { HaPatientimport } from '../../models/HaPatientImport.model';
import { HaConflictedPatientRecordsModel } from '../../models/HaConflictedPatientRecords.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { OtherInfoEnum } from './OtherInfoEnum';
import { FinalPatientSubmitModal } from '../../models/FinalPatientSubmit.model';
import { ErrorModel } from '../../../../shared/models/Error.model';
import { debug } from 'util';
declare var $: any;

@Component({

  selector: 'app-ha-patient-list',
  templateUrl: './ha-patient-list.component.html',
  styleUrls: ['./ha-patient-list.component.css']
})

export class HaPatientListComponent implements OnInit {
    @ViewChild('selectedDoctor', { static: true }) selectedDoctor: ElementRef;
    myFileName: any;
    showProgress: boolean = false;

    fileSelected = false;
  loadingExcelPercentage: number;
  element: HTMLElement;
  elementMain: HTMLElement;
  page: number = 1;
  buttonClicked: boolean = false;
  rejectExport: boolean = false;
  patientList: any[];
  showCaseReportLoad: boolean = false;
  doctorList: any[];
  popUpDiv: boolean;
  patientIdOnClick;
  patientInfo: any = [];
  elementSlide: HTMLElement;
  otherMed: any[];
  surgicalData: any[];
  vitamins: any[];
  allergies: any[];
  vendors: any[];
  caseReport: string = '';
  scheduledBy;
  totalCaseData;
  showCaseCodeLoad: boolean = false;
  caseName;
  dateSelect;
  searchTermDoctorTwo: string = '';
  // doctorInfo: any;
  caseNameOne;
  copy: number = 1;
  scheduledInfo: any;
  showInsertedData: boolean = false;
  cases: any[];
  showOverlayPatientList: boolean;
  showPatientListLoad: boolean;
  showPatientLoad: boolean;
  counterForLoader = 1;
  patientListShow: boolean;
  doctorName: string;
  eaIdFilter: any[];
  pdfReports: PdfData[] = [];
  pdfData: PdfData;
  index: string = '1';
  selectedDoctorName: string = '';
  headerText: string;
  currentListShow: boolean = false;
  activeElementCode: string = '1';
  activeElementTab: string = '1';
  currentList: any[];
  docShare: any[] = [];
  docShareSchedule: any[] = [];
  currentPatient: string;
  noteText: any;
  showReport: boolean = false;
  rejectedListTemp: HaPatientimport[];
  selectedData: HaPatientimport[] = [];
  uploadDulpicate: boolean = false;
  fileName: string = '';
  currentScheduleId: string;
  checkAll: boolean = false;
  showPatientImportData: boolean = false;
  showInsertedDataTwo: boolean = false;
  insertModalShow: boolean = false;
  listView: boolean = false;
  insertedList: HaPatientimport[];
  tempInsertedList: HaPatientimport[];
  rejectedList: HaPatientimport[];
  temprejectedList: HaPatientimport[];
  conflictedList: HaConflictedPatientRecordsModel[];
  tempConflictedList: HaConflictedPatientRecordsModel[];
  allSelected: boolean = false;
  resolvedItems: HaPatientimport[];
  selectedDoctorImport: string;
  totalPatientCount: number;
  searchTermDoctorOne: string = '';
  showPdfLoad: boolean;
  elementIcd: HTMLElement;
  elementCpt: HTMLElement;
  elementPre: HTMLElement;
  elementProc: HTMLElement;
  elementMed: HTMLElement;
  elementVendor: HTMLElement;
  currentListPatient: any[];
  dataList: any[];
  surveyList: any[];
    display;

  patientCount: number = 0;
  searchTerm:string = 'run';
  currentDoctor: string = '';
  patientInfoError = new ErrorModel();
  mainViewError = new ErrorModel();
  caseCodeError = new ErrorModel();
  scheduledInfoError = new ErrorModel();
  pdfError = new ErrorModel();
  shareError = new ErrorModel();
  caseShareError = new ErrorModel();
  shareLoaderMain:boolean = false;
  shareLoaderSlide:boolean = false;
  doctorArchived: any[] = [];
  constructor(private _service: HaPatientlistService, private Saniti: DomSanitizer, private router: Router) {

  }

  ngOnInit() {
      this.display = 'none';
    this.patientCount = 0;
    this.buttonClicked = false;
    this.resolvedItems = [];
    this.tempConflictedList = [];
    this.dateSelect = new Date().toJSON().split('T')[0];
    this.showOverlayPatientList = true;
    this.getPatientList(1, '', '');
    this.getDoctors();
    this.pdfData = new PdfData();
  }

  arrayBuffer: any;
  file: File;

  getDoctors() {

    this.showPatientListLoad = true;

    this._service.getDoctorsList().subscribe(
    (data: any[]) => {
      this.doctorList = data;
    },
    (error) => {
      this.getPatientList(1, '', '');
      AlertMessages.Show('Failed', 'Could not load all data!', AlertType.Error);

    }).add(() => {
      this.showPatientListLoad = false;

    });
  }

  onTotalCaseClick(indexSelected) {
    this.activeElementTab = indexSelected;
    this.showReport = false;
  }

  onAppointmentClick(indexSelected) {
    this.activeElementTab = indexSelected;
    if (this.cases != undefined && this.cases != null) {
      if (this.cases.length > 0) {
        this.getPatientScheduledInfo(false,this.cases[0].sId);
      }
    }
  }

  onSurveyClick(indexSelected) {
    this.activeElementTab = indexSelected;
  }


  getPatientList(pageNo: number, text: string, docId: string) {
    this.mainViewError.display = false;
    this.searchTerm = text;
    this.currentDoctor = docId;
    if (this.counterForLoader == 1) {
      this.counterForLoader = this.counterForLoader + 1;
    } else {
      this.showPatientListLoad = true;
    }

    this._service.getPatientList(pageNo, text.trim(), docId).subscribe(
    (data) => {
      this.patientList = data['patientList'];
      this.patientCount = data['patCount'];
      for (let index = 0; index < this.patientList.length; index++) {
        let dateValue: string = this.patientList[index]['ScheduleDate'];
        let firstIndex = dateValue.indexOf('(');
        let lastIndex = dateValue.lastIndexOf(')');
        let milliValue = dateValue.substring(firstIndex + 1, lastIndex);
        this.patientList[index]['scheduledDate'] = ((milliValue == '852057000000') || (milliValue == '852076800000')) ? 'Not yet Scheduled' : new Date(this.patientList[index]['schDate']).toLocaleDateString('default');
      }
      if (this.patientList.length == 0) {
        this.patientInfo = [];
        this.patientListShow = true;
        this.doctorName = '';
      } else {
        this.patientListShow = false;
      }

      this.page = 1;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showPatientListLoad = false;
      this.showOverlayPatientList = false;
    });
  }

  onScroll(patientVal, docVal) {
    this.showPatientListLoad = true;
    this.page = this.page + 1;
    this._service.getPatientList(this.page, patientVal.trim(), docVal).subscribe(
    (data) => {
      let patientData: any[] = data['patientList'];
      if (patientData != undefined) {
        patientData.forEach(i => {
          let dateValue: string = i['ScheduleDate'];
          let firstIndex = dateValue.indexOf('(');
          let lastIndex = dateValue.lastIndexOf(')');
          let milliValue = dateValue.substring(firstIndex + 1, lastIndex);
          i['scheduledDate'] = ((milliValue == '852057000000') || (milliValue == '852076800000')) ? 'Not yet Scheduled' : new Date(i['schDate']).toLocaleDateString('default');
          this.patientList.push(i);
        });
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load', AlertType.Error);
    }).add(() => {
      this.showPatientListLoad = false;
    });
  }

  showTemplate(id) {
    this.surveyList = [];
    this.patientInfoError.display = false;
    this.cases = [];
    this.surveyList = [];

    for (let patient of this.patientList) {
      patient.border = '';
      patient.borderBottom = '';
    }
    let index = this.patientList.findIndex(patient => patient.id == id);
    this.patientList[index].border = '2px solid #0969c9';
    this.patientList[index].borderBottom = '2px solid #0969c9';
    this.patientInfo = [];
    this.showPatientLoad = true;
    this.patientIdOnClick = id;
    this.patientInfo = this.patientList.filter(patient => patient.id == id)[0];
    this.doctorName = this.patientList[index].doctorName;
    this._service.getPatientOtherInformation(this.patientIdOnClick).subscribe(
    (data: any[]) => {
      this.otherMed = data['medicines'];
      this.surgicalData = data['surgicalHistories'];
      this.vitamins = data['vitamins'];
      this.allergies = data['allergies'];
      this.changeDiv('1');
    },
    (error) => {
      this.patientInfoError.error = error;
      this.patientInfoError.display = true;
    });

    this.totalCaseData = 0;
    this._service.getPatientCases(this.patientIdOnClick).subscribe(
    (data: any[]) => {
      this.cases = data;
      if (this.cases != undefined && this.cases != null) {
        if (this.cases.length > 0) {
          this.cases.forEach(el => {
            let date = new Date(el.frmDate);
            el.fromDate = date.getDate() + '/' + (1 + parseInt(date.getMonth().toString())) + '/' + date.getFullYear();
            el.fromtime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
          });
          this.totalCaseData = this.cases.length;
          this.showPatientLoad = false;
        }
      } else {
        this.totalCaseData = 0;
        this.showPatientLoad = false;
      }
    },
    (error) => {
      this.patientInfoError.error = error;
      this.patientInfoError.display = true;
    }).add(() => {
      this.showPatientLoad = false;
    });

    this._service.getSurveyList(this.patientIdOnClick).subscribe(
    (data: any[]) => {
      this.surveyList = data;
    },
    (error) => {
      this.patientInfoError.error = error;
      this.patientInfoError.display = true;
    });

    this.element = document.getElementById('showpatientlist');
    this.element.style.display = 'block';
  }

  getCaseCode(caseId, caseName) {
    this.caseCodeError.display = false;
    this.showCaseCodeLoad = true;
    this.caseName = caseName;
    this.dataList = [];
    this._service.getCaseCode(caseId).subscribe(
    (data: any[]) => {
      this.dataList = data;
      this.changeDivCodes('1');
    },
    (error) => {
      this.caseCodeError.error = error;
      this.caseCodeError.display = true;

    }).add(() => {
      this.showCaseCodeLoad = false;
    });
  }

  onEventView(event, sId) {
    event.stopPropagation();
    this.getPatientScheduledInfo(true,sId);
  }

  onEventpdf(event, scheduledId, scheduledBy, casename) {
    this.showReport = true;
    event.stopPropagation();
    this.getPdfReport(scheduledId, scheduledBy, casename);
  }

  getPatientScheduledInfo(type, sId) {
    if (type) $('#scheduleModal').modal('show');
    if (type) this.scheduledInfoError.display = false;
    this.resetCases();
    let index = this.cases.findIndex(caseIs => caseIs.sId == sId);
    this.addBorder(index);
    this._service.getPatientScheduledInfo(sId).subscribe(
    (data: any) => {
      this.scheduledInfo = data;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not get Info!', AlertType.Error);
      if (type) {
        this.scheduledInfoError.error = error;
        this.scheduledInfoError.display = true;
      }
    });
  }

  getPdfReport(scheduledId, scheduledBy, CaseName) {
    this.showCaseReportLoad = true;
    this.caseReport = CaseName;
    this._service.getPatientPdfData(scheduledId).subscribe(
    (data: PdfData[]) => {
      this.scheduledBy = scheduledBy;
      this.pdfReports = data;
      for (let i = 0; i < this.pdfReports.length; i++) {
        this.pdfReports[i]['CreateTDate'] = new Date(this.pdfReports[i]['CreateDate']);
      }
      this.pdfReports.forEach(i => {
        let fmDate = new Date(i.createDate);
        i.crDate = fmDate.getDate() + '-' + (1 + parseInt(fmDate.getMonth().toString())) + '-' + fmDate.getFullYear();
      });
    },
    (error) => {
      this.showReport = false;
      AlertMessages.Show('Failed', 'Could not get pdf data!', AlertType.Error);

    }).add(() => {
      this.showCaseReportLoad = false;
    });
  }

  closePdfLoad() {
    this.showPdfLoad = false;
  }

  getSinglePdf(pdf, id) {
    this.showPdfLoad = true;
    this.pdfError.display = false;
    this.pdfData = new PdfData();
    $('#PdfModal').modal('show');
    this._service.getSinglePdf(id).subscribe(
    (data) => {
      this.pdfData = this.pdfReports.filter(pdfIs => pdfIs.id == id)[0];
    },
    (error) => {
      this.pdfError.error = error;
      this.pdfError.display = true;
    }).add(() => {
      this.showPdfLoad = false;
    });
  }

  goBack() {
    this.scheduledBy = '';
    this.caseReport = '';
    this.showReport = false;
    this.pdfReports = [];
    this.showCaseReportLoad = false;
  }

  openNav(patientId) {
    this.activeElementTab = '1';
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = '0px';
    this.elementSlide.style.opacity = '1';
    this.showTemplate(patientId);
    this.elementMain = document.getElementById('patientlistloaddiv') as HTMLElement;
    this.elementMain.style.width = '50%';
  }

  closeNav() {
    this.scheduledBy = '';
    this.caseReport = '';
    this.showReport = false;
    this.pdfReports = [];
    for (let patient of this.patientList) {
      patient.border = '';
    }
    this.activeElementTab = '1';
    this.elementSlide = document.getElementById('slideDiv') as HTMLElement;
    this.elementSlide.style.marginRight = '-105%';
    this.elementSlide.style.opacity = '0';
    this.elementMain = document.getElementById('patientlistloaddiv') as HTMLElement;
    this.elementMain.style.width = '100%';
  }

  copyToClip(data) {

    data.evt.stopPropagation();
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '-120%';
    selBox.style.top = '-50%';
    selBox.style.opacity = '0';
    selBox.value = data.patientId;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy', false, data.patientId);
    AlertMessages.Show('Copied', ' ' + data.patientId + ' is Copied', AlertType.Success);
  }

  onEventPatientShare(data) {
    data.evt.stopPropagation();
    this.shareToDoc(data.patientId, data.evt);
  }

  shareToDoc(element, event) {
    this.currentPatient = element;
    this.shareError.display = false;
    event.stopPropagation();
    $('#shareModal222').modal('show');
    this._service.getDoctors(element).subscribe(
    (data: any[]) => {
      this.docShare = data;
    },
    (error) => {
      this.shareError.error = error;
      this.shareError.display = true;
    });
  }

  sharePatient(doctor) {
    this.shareLoaderMain = true;
    this._service.sharePatient(this.currentPatient, doctor.id, doctor.hospId).subscribe(
    (data) => {
      AlertMessages.Show('Shared', 'Shared with selected Doctor', AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not share!', AlertType.Error);
    }).add(() => {
      this.shareLoaderMain = false;
    });
  }

  onEventPatientCaseShare(sId, event) {
    event.stopPropagation();
    this.shareScheduledToDoc(sId, event);
  }

  shareScheduledToDoc(element, event) {
    this.currentScheduleId = element;
    this.caseShareError.display = false;
    event.stopPropagation();
    $('#shareModal222sch').modal('show');
    this._service.getDoctorsSch(element).subscribe(
    (data: any[]) => {
      this.docShareSchedule = data;
    },
    (error) => {
     this.caseShareError.error = error;
     this.caseShareError.display = true;
    });
  }

  sharePatientSchedule(schedule) {
    this.shareLoaderSlide = true;
    this._service.shareSchedule(this.currentScheduleId, schedule.id, schedule.hospId).subscribe(
    (data) => {
      AlertMessages.Show('Shared', 'Shared with selected user(s)', AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failure', 'Could not share', AlertType.Error);

    }).add(() => {
      this.shareLoaderSlide = false;
    });
  }

  changeDiv(infoType) {
    this.activeElementCode = infoType;
    if (infoType == OtherInfoEnum.OtherMedicines) {
      this.currentList = this.otherMed;
      this.headerText = 'List of Other Medicine';
    } else if (infoType == OtherInfoEnum.Vitamins) {
      this.currentList = this.vitamins;
      this.headerText = 'List of Vitamins';
    } else if (infoType == OtherInfoEnum.Allergies) {
      this.currentList = this.allergies;
      this.headerText = 'List of Allergies';
    } else if (infoType == OtherInfoEnum.SurgicalHistories) {
      this.currentList = this.surgicalData;
      this.headerText = 'List of Surgical History';
    }

    if (this.currentList != null && this.currentList != undefined) {

      this.currentListShow = this.currentList.length < 1 ? true : false;
    } else {
      this.currentListShow = true;
    }
  }


    incomingFile(event) {
       
      document.getElementById("UploadBtn").style.display="inline";
      document.getElementById("hide").style.display="inline";
        this.file = event.target.files[0];
      //  this.myFileName = { "filename": "hsdss" };
    }

  uploadExcel(selectedDoctor) {
    this.totalPatientCount = 0;
    this.selectedDoctorImport = selectedDoctor;
    this.showProgress = true;
    if (this.file == undefined || this.file == null) {
      this.showProgress = false;
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .csv ) to upload ', AlertType.Warning);
    } else if (this.file.name.search(/.csv|.bmp /g) == -1) {
      this.showProgress = false;
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .csv ) to upload ', AlertType.Warning);
    } else {
      this._service.uploadPatientExcel(this.file).subscribe(
      (event) => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingExcelPercentage = Math.round(event.loaded / event.total * 100);
        } else if (event.type == HttpEventType.Response) {
          this.uploadDulpicate = true;
          this.showProgress = false;
          this.display = 'none';
          this.fileName = '';
          this.selectedDoctorName = '';
          if(event.body == '' || event.body==null || event.body==undefined)
          {
            this.showOverlayPatientList = false;
            AlertMessages.Show('Error','the sheet does not contain relevant data',AlertType.Error);
          } else{
          this.rejectedList = event.body['rejectedList'] as HaPatientimport[];
          this.insertedList = event.body['insertedList'] as HaPatientimport[];
          this.conflictedList = event.body['conflictedRecords'] as HaConflictedPatientRecordsModel[];
          this.totalPatientCount = this.insertedList.length + this.rejectedList.length + ((this.conflictedList.length) / 2);
          this.showOverlayPatientList = false;
          this.showInsertedData = true;
          if (this.insertedList.length > 0) {
            this.insertModalShow = true;
          }
        }
        }
      }, (error: HttpErrorResponse) => { this.showProgress = false; AlertMessages.Show('Failed', 'Could not upload!', AlertType.Error)});

      }

      document.getElementById("UploadBtn").style.display = "none";
      document.getElementById("hide").style.display = "none";

  }

  selectImportPatient(event, patientId) {
    if (event.target.checked == true) {
      let val = this.conflictedList.filter(conflict => conflict.patientId == patientId);
      this.conflictedList.forEach((e) => {
        if (e.patientId == patientId) {
          e.backColor = '#F7F663';
          if (e.valueType == 1) {
            e.isChecked = true;
          }
        }
      })
    } else {
      this.allSelected = false;
      let val = this.conflictedList.filter(conflict => conflict.patientId == patientId);
      this.conflictedList.forEach((e) => {
        if (e.patientId == patientId) {
          e.backColor = 'white';
          if (e.valueType == 1) {
            e.isChecked = false;
          }
        }
      })
    }
  }


  selectAllConflictedRecords(event) {
    if (event.target.checked == true) {
      this.allSelected = true;
      this.conflictedList.forEach((e) => {
        if (e.resolved == false) {
          e.backColor = '#F7F663';
          if (e.valueType == 1) {
            e.isChecked = true;
          }
        }
      })
    } else {
      this.allSelected = false;
      this.conflictedList.forEach((e) => {
        if (e.resolved == false) {
          e.backColor = 'white';
          e.isChecked = false;
        }
      })
    }
  }

  merge() {
    if (this.conflictedList != undefined) {
      if (this.conflictedList.filter(conflict => conflict.isChecked == true && conflict.resolved == false).length > 0) {
        let fileItems = this.conflictedList.filter(conflict => conflict.isChecked == true && conflict.valueType == 1 && conflict.resolved == false);
        fileItems.forEach((i) => {
          let newItem = new HaPatientimport();
          let dbItem = this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 0)[0];
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 0)[0].isVisible = false;
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].resolved = true;
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].backColor = '#C8FDD3';
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].checkBoxVisible = false;
          newItem.id = dbItem.id;
          newItem.firstName = ((dbItem.firstName == '') || (dbItem.firstName == null) || (dbItem.firstName == undefined)) ? i.firstName : dbItem.firstName;
          newItem.middleName = ((dbItem.middleName == '') || (dbItem.middleName == null) || (dbItem.middleName == undefined)) ? i.middleName : dbItem.middleName;
          newItem.lastName = ((dbItem.lastName == '') || (dbItem.lastName == null) || (dbItem.lastName == undefined)) ? i.lastName : dbItem.lastName;
          newItem.address = ((dbItem.address == '') || (dbItem.address == null) || (dbItem.address == undefined)) ? i.address : dbItem.address;
          newItem.bloodGroup = ((dbItem.bloodGroup == '') || (dbItem.bloodGroup == null) || (dbItem.bloodGroup == undefined)) ? i.bloodGroup : dbItem.bloodGroup;
          newItem.country = ((dbItem.country == '') || (dbItem.country == null) || (dbItem.country == undefined)) ? i.country : dbItem.country;
          newItem.emailId = ((dbItem.emailId == '') || (dbItem.emailId == null) || (dbItem.emailId == undefined)) ? i.emailId : dbItem.emailId;
          newItem.mobileNo = ((dbItem.mobileNo == '') || (dbItem.mobileNo == null) || (dbItem.mobileNo == undefined)) ? i.mobileNo : dbItem.mobileNo;
          newItem.insurance = ((dbItem.insurance == '') || (dbItem.insurance == null) || (dbItem.insurance == undefined)) ? i.insurance : dbItem.insurance;
          newItem.sex = dbItem.sex;
          newItem.ssn = ((dbItem.ssn == '') || (dbItem.ssn == null) || (dbItem.ssn == undefined)) ? i.ssn : dbItem.ssn;
          newItem.vitamins = ((dbItem.vitamins == '') || (dbItem.vitamins == null) || (dbItem.vitamins == undefined)) ? i.vitamins : dbItem.vitamins;
          newItem.otherMedicine = ((dbItem.otherMedicine == '') || (dbItem.otherMedicine == null) || (dbItem.otherMedicine == undefined)) ? i.otherMedicine : dbItem.otherMedicine;
          newItem.surgicalHistory = ((dbItem.surgicalHistory == '') || (dbItem.surgicalHistory == null) || (dbItem.surgicalHistory == undefined)) ? i.surgicalHistory : dbItem.surgicalHistory;
          newItem.knownAllergy = ((dbItem.knownAllergy == '') || (dbItem.knownAllergy == null) || (dbItem.knownAllergy == undefined)) ? i.knownAllergy : dbItem.knownAllergy;
          newItem.state = ((dbItem.state == '') || (dbItem.state == null) || (dbItem.state == undefined)) ? i.state : dbItem.state;
          newItem.city = ((dbItem.city == '') || (dbItem.city == null) || (dbItem.city == undefined)) ? i.city : dbItem.city;
          newItem.Dob = dbItem.Dob;
          newItem.zip = ((dbItem.zip == '') || (dbItem.zip == null) || (dbItem.zip == undefined)) ? i.zip : dbItem.zip;
          newItem.patientId = dbItem.patientId;
          newItem.sexView = dbItem._sex;
          newItem.dobShow = dbItem.dobShow;
          this.insertedList.push(newItem);
        })
      } else {
        AlertMessages.Show('WARNING', 'Please select a item to merge', AlertType.Warning);
      }
    } else {
      AlertMessages.Show('WARNING', 'No items to merge', AlertType.Warning);
    }
  }


  replace() {
    if (this.conflictedList != undefined) {
      if (this.conflictedList.filter(conflict => conflict.isChecked == true && conflict.resolved == false).length > 0) {
        let fileItems = this.conflictedList.filter(conflict => conflict.isChecked == true && conflict.valueType == 1 && conflict.resolved == false);
        fileItems.forEach((i) => {
          let newItem = new HaPatientimport();
          let dbItem = this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 0)[0];
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 0)[0].isVisible = false;
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].resolved = true;
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].backColor = 'lightblue';
          this.conflictedList.filter(conflict => conflict.patientId == i.patientId && conflict.valueType == 1)[0].checkBoxVisible = false;
          newItem.id = dbItem.id;
          newItem.firstName = i.firstName;
          newItem.middleName = i.middleName;
          newItem.lastName = i.lastName;
          newItem.address = i.address;
          newItem.bloodGroup = i.bloodGroup;
          newItem.country = i.country;
          newItem.emailId = i.emailId;
          newItem.mobileNo = i.mobileNo;
          newItem.insurance = i.insurance;
          newItem.sex = i.sex;
          newItem.ssn = i.ssn;
          newItem.vitamins = i.vitamins;
          newItem.otherMedicine = i.otherMedicine;
          newItem.surgicalHistory = i.surgicalHistory;
          newItem.knownAllergy = i.knownAllergy;
          newItem.state = i.state;
          newItem.city = i.city;
          newItem.Dob = i.Dob;
          newItem.zip = i.zip;
          newItem.patientId = i.patientId;
          newItem.sexView = dbItem._sex;
          newItem.dobShow = dbItem.dobShow;
          this.insertedList.push(newItem);
        })
        this.conflictedList.filter(conflict => conflict.isChecked == true && conflict.valueType == 1 && conflict.resolved == true).forEach((el => {
          el.checkBoxVisible = false;
          el.backColor = '#C8FDD3';
        }))
      } else {
        AlertMessages.Show('WARNING', 'Please select a item to Replace', AlertType.Warning);
      }
    } else {
      AlertMessages.Show('WARNING', 'No items selected to Replace', AlertType.Warning);
    }
  }


  finalSubmitImportPatient() {
    if (this.insertedList != undefined && this.insertedList != null) {
      if (this.insertedList.length > 0) {
        this.showOverlayPatientList = true;
        this.buttonClicked = true;
        let finalSaveModal:FinalPatientSubmitModal = new FinalPatientSubmitModal(this.insertedList,this.selectedDoctorImport);
        this._service.finalSavePatientImport(finalSaveModal).subscribe(
        (data) => {

          this.cancelPatientImport();
          AlertMessages.Show('Success', data + 'Patients Submitted Successfully', AlertType.Success);
          this.getPatientList(1, '', '');
        },
        (error) => {
          AlertMessages.Show('Failed', 'Could not Submit!', AlertType.Error);
        }).add(() => {
          this.showOverlayPatientList = false;
        });
      }
    } else {
      AlertMessages.Show('WARNING', 'No Data selected', AlertType.Warning);
    }
  }

  cancelPatientImport() {
    this.insertedList = [];
    this.resolvedItems = [];
    this.selectedDoctorImport = '';
    this.showInsertedData = false;
    this.showInsertedDataTwo = false;
    this.allSelected = false;
    this.buttonClicked = false;
  }

  exportRejectedList() {
    this.showOverlayPatientList = true;
    this._service.expotRejectedList(this.rejectedList).subscribe(
    (data) => {
      this.rejectExport = true;
      this.showOverlayPatientList = false;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not export!', AlertType.Error);

    });
  }

  closeDownload() {
    this.rejectExport = false;
  }

  showInserted() {
    this.insertModalShow = true;
  }

  hideInserted() {
    this.insertModalShow = false;
  }

  shareAllPatient() {
    this.router.navigate(['Hospital/HAAdmin/HaSharePatient'], {
      queryParams: {}
    });
  }

  onEventViewNote(event, sId, note) {
    event.stopPropagation();
    this.getPatientNote(sId, note);
  }

  getPatientNote(sId, note) {
    $('#scheduleModalllnotes').modal('show');
    this.resetCases();
    let index = this.cases.findIndex(caseIs => caseIs.sId == sId);
    this.addBorder(index);
    let selectedNote = note;
    this.noteText = this.Saniti.bypassSecurityTrustHtml(selectedNote);
    if (selectedNote == undefined || selectedNote == null || selectedNote == '') {
      this.popUpDiv = true;
    } else {
      this.popUpDiv = false;
    }
  }

  //------------------------------------------------
  resetCases() {
    for (let v of this.cases) {
      v.borderLeft = '';
      v.borderRight = '';
      v.borderBottom = '';
    }
  }

  addBorder(index) {
    this.cases[index].borderLeft = '2px solid #0969c9';
    this.cases[index].borderRight = '2px solid #0969c9';
    this.cases[index].borderBottom = '2px solid #0969c9';
  }

  public activeElementCodepat = '1'

  changeDivCodes(index) {
    this.showCaseCodeLoad = true;
    this.elementIcd = document.getElementById('ICD_Div');
    this.elementCpt = document.getElementById('CPT_Div');
    this.elementPre = document.getElementById('Preop_Div');
    this.elementProc = document.getElementById('Proced_Div');
    this.elementMed = document.getElementById('medical_Div');
    this.elementVendor = document.getElementById('vendor_Div');
    this.activeElementCodepat = index;
    this.elementIcd.style.display = index == '1' ? 'block' : 'none';
    this.elementCpt.style.display = index == '2' ? 'block' : 'none';
    this.elementMed.style.display = index == '3' ? 'block' : 'none';
    this.elementPre.style.display = index == '4' ? 'block' : 'none';
    this.elementProc.style.display = index == '5' ? 'block' : 'none';
    this.elementVendor.style.display = index == '6' ? 'block' : 'none';
    this.currentListPatient = [];
    switch (index) {
      case '1': {
        this.currentListPatient = this.dataList['icdCodes'];
        break;
      }
      case '2': {
        this.currentListPatient = this.dataList['cptCodes'];
        break;
      }
      case '3': {
        this.currentListPatient = this.dataList['preopCodes'];
        break;
      }
      case '4': {
        this.currentListPatient = this.dataList['procedures'];
        break;
      }
      case '5': {
        this.currentListPatient = this.dataList['medDevices'];
        break;
      }
      case '6': {
        this.currentListPatient = this.dataList['vendors'];
        break;
      }
      default: {
        this.currentListPatient = [];
      }
    }

    this.showCaseCodeLoad = false;

  }

  goToSurvey(linkCode) {
    let url = 'SurveyViaLink?LinkCode=' + linkCode.trim();
    window.open(url, '_blank');
  }

    openImport() {
        //document.getElementById("UploadBtn").style.display = "none";
        document.getElementById("UploadBtn").style.display = "none";
        document.getElementById("hide").style.display = "none";
       // document.getElementById('uploadFilespan').textContent = "";

        if (!(this.selectedDoctor == undefined)) {
          
            this.selectedDoctor.nativeElement.value = null;
        }    
       
    this.display = 'block';
  }

    cancelImport() {
      this.display = 'none';
      document.getElementById("UploadBtn").style.display="none";
      document.getElementById("hide").style.display="none";
    }

  showDoctorsWhoArchived(data) {
    this.doctorArchived = data.list;
    data.evt.stopPropagation();
    $('#doctorsWhoArch').modal('show');
  }
}
